<template>
	<header class="header">
		<div class="wrapper">
			<div class="left">
				<router-link to="/" class="logo">
					<img src="./../img/logo.svg" class="img" />
				</router-link>
			</div>
			<ul class="nav">
				<li class="nav__item">
					<router-link class="desc" to="/" exact>
						<b>{{ $t('Главная') }}</b>
					</router-link>
				</li>
				<li
					:class="['nav__item', { active: $route.name == 'Products' }]"
					v-if="$parent.categories && $parent.categories.length"
				>
					<button
						@click="$emit('chooseCategoty', $parent.categories[0])"
						class="desc"
					>
						<b>{{ $t('Магазин') }}</b>
					</button>
				</li>
				<li class="nav__item">
					<router-link class="desc" to="/rules">
						<b>{{ $t('Правила') }}</b>
					</router-link>
				</li>
				<li class="nav__item">
					<router-link class="desc" to="/faq">
						<b>{{ $t('FAQ') }}</b>
					</router-link>
				</li>
				<li class="nav__item">
					<button class="desc" @click="$parent.openContactUs()">
						<b>{{ $t('Контакты') }}</b>
					</button>
				</li>
			</ul>
			<div class="right">
				<LanguageSelectDropdown
					v-if="allLanguages && allLanguages.length > 1"
				/>
				<div class="currency-dropdown-wrapper" v-if="currencies.length > 1">
					<select
						v-model="selectedCurrency"
						class="currency-dropdown"
						@change="onCurrencyChange"
					>
						<option
							v-for="currency in currencies"
							:key="currency.code"
							:value="currency.code"
						>
							{{ currency.symbol || currency.code }}
						</option>
					</select>
				</div>
				<router-link
					to="/cart"
					class="cart-icon button bordered"
					v-if="$parent.isAuth"
				>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_3_454)">
							<path
								d="M7.50002 18.3333C7.96026 18.3333 8.33335 17.9602 8.33335 17.5C8.33335 17.0398 7.96026 16.6667 7.50002 16.6667C7.03978 16.6667 6.66669 17.0398 6.66669 17.5C6.66669 17.9602 7.03978 18.3333 7.50002 18.3333Z"
								stroke="currentColor"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M16.6666 18.3333C17.1269 18.3333 17.5 17.9602 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6666 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9602 16.2064 18.3333 16.6666 18.3333Z"
								stroke="currentColor"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M0.833313 0.833328H4.16665L6.39998 11.9917C6.47618 12.3753 6.6849 12.72 6.9896 12.9652C7.2943 13.2105 7.67556 13.3408 8.06665 13.3333H16.1666C16.5577 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.72 17.7571 12.3753 17.8333 11.9917L19.1666 5H4.99998"
								stroke="currentColor"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0_3_454">
								<rect width="20" height="20" fill="white" />
							</clipPath>
						</defs>
					</svg>

					<div v-if="$parent.cartContents.length" class="indicator">
						{{ $parent.cartContents.length }}
					</div>
				</router-link>
				<router-link
					to="/profile"
					class="button profile-button"
					v-if="$parent.isAuth"
				>
					<svg
						width="26"
						height="26"
						viewBox="0 0 26 26"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect
							width="26"
							height="26"
							rx="8"
							fill="#08110C"
							fill-opacity="0.22"
						/>
						<path
							d="M18 18.625V17.375C18 16.712 17.7366 16.0761 17.2678 15.6072C16.7989 15.1384 16.163 14.875 15.5 14.875H10.5C9.83696 14.875 9.20107 15.1384 8.73223 15.6072C8.26339 16.0761 8 16.712 8 17.375V18.625"
							stroke="#08110C"
							stroke-width="1.25"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M13 12.375C14.3807 12.375 15.5 11.2557 15.5 9.875C15.5 8.49429 14.3807 7.375 13 7.375C11.6193 7.375 10.5 8.49429 10.5 9.875C10.5 11.2557 11.6193 12.375 13 12.375Z"
							stroke="#08110C"
							stroke-width="1.25"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span>{{ $t('Кабинет') }}</span>
				</router-link>
				<div class="link-container" v-else>
					<button
						class="button signin-button"
						@click="$parent.openSignIn()"
					>
						{{ $t('Войти') }}
					</button>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import LanguageSelectDropdown from '@/components/LanguageSelectDropdown.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import useCurrency from '../utils/useCurrency';

export default {
	name: 'Header',

	components: {
		LanguageSelectDropdown,
	},

	data() {
		return {
			selectedCurrency: '',
			removeCurrencyListener: null,
		};
	},

	computed: {
		...mapState({
			languages: ({ app: { languages } }) =>
				languages.map(({ id, title: text }) => ({
					id,
					text,
				})),

			currentLanguage: (state) => state.app.currentLanguage,
		}),

		...mapGetters('app', ['currentLanguageName', 'allLanguages']),

		currencies() {
			return useCurrency().state.currencies;
		},

		language: {
			get() {
				return this.currentLanguage;
			},

			set(languageId) {
				this.changeLocale(languageId);
			},
		},
	},

	methods: {
		...mapMutations('app', ['setCurrentLanguage']),

		...mapActions('app', ['changeLocale']),

		async loadCurrencies() {
			const currencyService = useCurrency();

			await currencyService.fetchCurrencies();

			this.selectedCurrency = currencyService.getCurrencyCode();
		},

		onCurrencyChange() {
			const currencyService = useCurrency();

			const selectedCurrencyObject = this.currencies.find(
				(currency) => currency.code === this.selectedCurrency,
			);

			if (!selectedCurrencyObject) {
				this.selectedCurrency = currencyService.getCurrencyCode();

				return;
			}

			currencyService.setCurrency(selectedCurrencyObject);

			this.selectedCurrency = currencyService.getCurrencyCode();
		},
	},

	async mounted() {
		const currencyService = useCurrency();

		await this.loadCurrencies();

		this.removeCurrencyListener = currencyService.onCurrencyChange(() => {
			this.selectedCurrency = currencyService.getCurrencyCode();
		});
	},

	beforeDestroy() {
		if (this.removeCurrencyListener) {
			this.removeCurrencyListener();
		}
	},
};
</script>

<style scoped lang="scss">
.currency-dropdown-wrapper {
	position: relative;
	display: inline-flex;
	border-radius: 999px;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		z-index: 0;

		border-radius: inherit;
		background: linear-gradient(180deg, var(--44) 0%, var(--31) 100%);

		opacity: 0;
		pointer-events: none;
		transition: opacity 0.3s ease;
	}

	@media (any-hover: hover) {
		&:hover {
			&::after {
				opacity: 1;
			}

			.currency-dropdown {
				color: var(--racing-green);
				border-color: transparent;
			}
		}
	}

	&:focus-within {
		&::after {
			opacity: 1;
		}

		.currency-dropdown {
			color: var(--racing-green);
			border-color: transparent;
		}
	}
}

.currency-dropdown {
	position: relative;
	z-index: 1;

	width: fit-content;
	padding: 8px 15px;

	font-family: var(--font-1);
	font-size: 14px;
	font-weight: 400;

	color: var(--harvest-gold);
	background: transparent;
	border: 1px solid var(--outer-space);
	border-radius: inherit;
	outline: none;
	cursor: pointer;

	transition: color 0.3s ease, border-color 0.3s ease;

	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
}
</style>
